import * as authModel from 'APP/model/auth/authModel';

export const redirectToADRegistration = async (): Promise<boolean> => {
  try {
    const registrationUrlData = await authModel.getRegistrationUrl();
    if (!registrationUrlData?.registrationUrl) {
      return false;
    }

    const backUri = new URL(window.location.origin + window.location.pathname).href;
    const registrationUrlObject = new URL(registrationUrlData.registrationUrl);
    registrationUrlObject.searchParams.set('back_uri', backUri);

    window.location.replace(registrationUrlObject);
    return true;
  } catch (error: any) {
    return false;
  }
};
